<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import backOff from '@/assets/animations/mobilescan_tutorial_step3.json';

export default {
  name: 'BackOff',
  mixins: [animation],
  props: {
    show: Boolean,
  },
  data: () => ({
    animationData: backOff,
    autoPlay: false,
  }),
  watch: {
    show(nv) {
      if (!this.animation) return;

      if (!nv) {
        this.animation.goToAndStop(0);
      }
    },
  },
};
</script>
